// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__27t3A","cell":"ColumnAccessor_cell__2m1Lh","firstCellAccent":"ColumnAccessor_firstCellAccent__4ZJ_4"};